import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

export default {
    findGroup: (id) => getRequest(`/groups/${id}`),
    updateGroup: (id, body) => patchRequest(`/groups/${id}`, body),
    findGroupAccounts: (id) => getRequest(`/groups/${id}/accounts`),
    findGroupUsers: (id) => getRequest(`/groups/${id}/users`),
    findGroupChannels: (id) => getRequest(`/groups/${id}/channels`),
    findGroupActivities: (id, filter = null, orderBy = null, skip = null, top = null) =>
        getRequest(
            `/groups/${id}/activities?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        ),
    listGroupSharedUrls: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/groups/${id}/shared-urls?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    findGroupTaskMap: (id) => getRequest(`/groups/${id}/task-maps`),
    listGroupTasks: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/groups/${id}/tasks?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    listGroupFiles: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/groups/${id}/files?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    createGroupAuthorities: (id, body) => postRequest(`/groups/${id}/authorities`, body),
    findGroupAuthorities: (id) => getRequest(`/groups/${id}/authorities`),
    updateGroupAuthorities: (id, body) => patchRequest(`/groups/${id}/authorities`, body),
    updateGroupChannels: (id, body) => patchRequest(`/groups/${id}/channels`, body),
    findGroupDashboard: (id) => getRequest(`/groups/${id}/dashboard`),
    findGroupContribution: (id) => getRequest(`/groups/${id}/contribution`),
    findGroupDistribution: (id) => getRequest(`/groups/${id}/distribution`),
    createGroupTaskMap: (id) => postRequest(`/groups/${id}/task-map`),
    createGroupTasks: (id, body) => postRequest(`/groups/${id}/tasks`, body),
    createGroupSharedUrl: (id, body) => postRequest(`/groups/${id}/shared-urls`, body),
    createGroupFile: (id, body) => postRequest(`/groups/${id}/files`, body),
    createGroupChannels: (id, body) => postRequest(`/groups/${id}/channels`, body),
    createGroupActivities: (id, body) => postRequest(`/groups/${id}/activities`, body),
    deleteGroupTaskMap: (id) => deleteRequest(`/groups/${id}/task-map`),
    deleteGroupSharedUrls: (id, body) => deleteRequest(`/groups/${id}/shared-urls`, body),
    deleteGroupFiles: (id, body) => deleteRequest(`/groups/${id}/files`, body),
    createGroupTaskMap: (id) => postRequest(`/groups/${id}/task-maps`),
    findGroupTaskMap: (id) => getRequest(`/groups/${id}/task-maps`),

    createChannel: (id, body) => postRequest(`/groups/${id}/channels`, body),
    listChannels: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/groups/${id}/channels?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    updateChannel: (id, body) => patchRequest(`/groups/${id}/channels`, body),
    deleteChannel: (id, body) => deleteRequest(`/groups/${id}/channels`, body),
    listGroupAIFeedback: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/groups/${id}/ai-feedback?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
};
